export default "__VITE_ASSET__E$l$XYRN__"